import textServices from 'services/text-services'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'

interface HowToParticipateProps {
  onCtaClick: () => void
}

// "¿Cómo participar?" (Figma 5595:12107): two glass cards side by side plus
// a wide third one, each with a floating blue step number.
const STEPS = [
  {
    number: 1,
    titleKey: 'pitstops/how/step1Title',
    titleFallback: 'Registrate en My Heineken',
    textKey: 'pitstops/how/step1Text',
    textFallback:
      'Tu camino hacia F1® comienza aquí. Crea tu cuenta en My Heineken para participar en la dinámica.'
  },
  {
    number: 2,
    titleKey: 'pitstops/how/step2Title',
    titleFallback: 'Participa en los Pit Stops',
    textKey: 'pitstops/how/step2Text',
    textFallback:
      'Cada semana se habilitará un nuevo reto, donde se sortearan 5 abonos dobles a Foro Sol por Pit Stop. Mantente atento y completa cada Pit Stop para seguir avanzando en la carrera.'
  },
  {
    number: 3,
    titleKey: 'pitstops/how/step3Title',
    titleFallback: 'Completa la carrera',
    textKey: 'pitstops/how/step3Text',
    textFallback:
      'Supera cada Pit Stop y completa la carrera. Recuerda, deberás completar todos los retos para ser uno de los posibles ganadores del premio final: un abono doble al Paddock.'
  }
] as const

const HowToParticipate = ({ onCtaClick }: HowToParticipateProps) => {
  return (
    <div className="pitstops__how">
      <h2 className="pitstops__how-title">
        {textServices.findByText('pitstops/how/title', '¿Cómo participar?')}
      </h2>
      <div className="pitstops__how-steps">
        {STEPS.map(({ number, titleKey, titleFallback, textKey, textFallback }) => (
          <div key={number} className={`pitstops__how-step pitstops__how-step--${number}`}>
            <span className="pitstops__how-step-number">{number}</span>
            <h3 className="pitstops__how-step-title">{textServices.findByText(titleKey, titleFallback)}</h3>
            <p className="pitstops__how-step-text">{textServices.findByText(textKey, textFallback)}</p>
          </div>
        ))}
      </div>
      <button
        type="button"
        className="home-v3__button pitstops__cta"
        onClick={() => {
          dlTrackEvent('user_interaction', {
            action: 'click',
            element: 'como participar :: quiero participar',
            section: 'pitstops'
          })
          onCtaClick()
        }}
      >
        {textServices.findByText('pitstops/how/cta', '¡Quiero participar!')}
      </button>
    </div>
  )
}

export default HowToParticipate
